module.exports = __webpack_public_path__ + "img/0Q3A3733_L_Foamcore_MockedUp.a6a18464.jpg";